var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showDialog
    ? _c(
        "modal",
        {
          attrs: {
            title: _vm.$t("add-sip-user"),
            width: "400",
            type: "question",
            "confirm-text": _vm.$t("save"),
            "cancel-text": _vm.$t("cancel"),
            "is-cta-disable": _vm.isCtaDisable,
            "confirm-loading": _vm.loading,
            "show-save-icon": true,
            persistent: "",
            "content-class": "devops-subdialog",
            "show-close-button": "",
          },
          on: {
            cancel: function ($event) {
              _vm.showDialog = false
            },
            confirm: _vm.handleSubmit,
          },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              staticClass: "px-4",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.handleSubmit.apply(null, arguments)
                },
              },
              model: {
                value: _vm.validForm,
                callback: function ($$v) {
                  _vm.validForm = $$v
                },
                expression: "validForm",
              },
            },
            [
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: [
                        _vm.rules.required(_vm.newUser.username, "username"),
                        _vm.rules.minLength(_vm.newUser.username),
                        _vm.rules.maxLength(_vm.newUser.username),
                        _vm.rules.userName(_vm.newUser.username),
                      ],
                      dense: "",
                      outlined: "",
                      "background-color": "light-primary",
                      label: _vm.$t("user-name-required"),
                    },
                    model: {
                      value: _vm.newUser.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.newUser, "username", $$v)
                      },
                      expression: "newUser.username",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: [
                        _vm.rules.required(
                          _vm.newUser.displayName,
                          "displayName"
                        ),
                        _vm.rules.minLength(_vm.newUser.displayName),
                        _vm.rules.maxLength(_vm.newUser.displayName),
                      ],
                      dense: "",
                      outlined: "",
                      "background-color": "light-primary",
                      label: _vm.$t("display-name-required"),
                    },
                    model: {
                      value: _vm.newUser.displayName,
                      callback: function ($$v) {
                        _vm.$set(_vm.newUser, "displayName", $$v)
                      },
                      expression: "newUser.displayName",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-block text-caption text--secondary mt-n3 mb-1",
                    },
                    [_vm._v(_vm._s(_vm.$t("sip-auto-password")))]
                  ),
                ],
                1
              ),
              _c("v-col", { staticClass: "pa-0" }, [
                _c(
                  "div",
                  { staticClass: "grey lighten-4 rounded pa-3 mt-2 mb-2" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-caption text--secondary text-center mb-2",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("sip-advanced-settings-hint")) +
                            " "
                        ),
                      ]
                    ),
                    _c("v-switch", {
                      staticClass: "mt-0 mb-0",
                      attrs: {
                        label: _vm.$t("sip-private-recording"),
                        dense: "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.newUser.privateRecording,
                        callback: function ($$v) {
                          _vm.$set(_vm.newUser, "privateRecording", $$v)
                        },
                        expression: "newUser.privateRecording",
                      },
                    }),
                    _c("v-select", {
                      staticClass: "mt-4",
                      attrs: {
                        items: _vm.groupItems,
                        label: _vm.$t("sip-default-group"),
                        hint: _vm.$t("sip-default-group-hint"),
                        "persistent-hint": "",
                        dense: "",
                        outlined: "",
                        "background-color": "white",
                        clearable: "",
                        "no-data-text": _vm.$t("no-groups-available"),
                      },
                      model: {
                        value: _vm.newUser.defaultUserGroupId,
                        callback: function ($$v) {
                          _vm.$set(_vm.newUser, "defaultUserGroupId", $$v)
                        },
                        expression: "newUser.defaultUserGroupId",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }